import {Component, Input} from '@angular/core'
import {Router} from '@angular/router'
import {AuthService} from '../../auth.service'
import {PaymentService} from '../../payment.service'
import {auth} from 'firebase'
import {NbToastrService} from '@nebular/theme'
// import { HttpClient, HttpHeaders, HttpOptions } from '@angular/common/http';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  providers: [PaymentService]
})
export class PaymentComponent {
  plans = []
  showTemplate = 'planSuscription'
  user: any
  selectedPlan: any
  submitted = false;
  constructor(
    private router: Router,
    public auth: AuthService,
    private paymentService: PaymentService,
    private toast: NbToastrService
  ) {
    this.plans = this.paymentService.planItems()
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.user = this.auth.getUser()
    })
  }

  async goPlan(keyPlan) {
    this.selectedPlan = this.plans.find(x => x.key === keyPlan)
    this.showTemplate = 'paymentCharge'
  }
  onSubmit(body) {
    //let headers = new Headers({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: headers });
    console.log("hola")

  }
  choosePlan() {
    console.log("entra a metodo");
    this.submitted = true;
    //document.getElementById("paypal_month").submit()
  }
}
